import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { deleteMerchantsPublicIDAvatar } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteMerchantAvatarMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID }: Parameters) =>
        deleteMerchantsPublicIDAvatar(merchantPublicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
